var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSecure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.708 13.94a1.564 1.564 0 00-.458 1.106L19 17.5c0 .864-.636 1.5-1.5 1.5l-2.454.25c-.415 0-.813.165-1.106.458l-1.834 1.834c-.61.61-1.601.61-2.212 0L8.06 19.708a1.565 1.565 0 00-1.106-.458L4.5 19c-.864 0-1.5-.636-1.5-1.5l-.25-2.454c0-.415-.165-.813-.458-1.106L.458 12.106a1.564 1.564 0 010-2.212L2.292 8.06c.293-.293.458-.691.458-1.106L3 4.5C3 3.636 3.636 3 4.5 3l2.454-.25c.415 0 .813-.165 1.106-.458L9.894.458a1.565 1.565 0 012.212 0l1.834 1.834c.293.293.691.458 1.106.458L17.5 3c.864 0 1.5.636 1.5 1.5l.25 2.454c0 .415.165.813.458 1.106l1.834 1.834c.61.61.61 1.601 0 2.212l-1.834 1.834zM8 10c-.599.113-1.019.553-.999 1v4c-.02.538.4.978 1 1h6c.6-.022 1.02-.462 1-1v-4c.02-.447-.4-.888-1-1V8a2 2 0 00-2-2h-2a2 2 0 00-2 2v2zm2-3h2a1 1 0 011 1v2H9V8a1 1 0 011-1z",
    fill: "#9BADBC"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSecure);
export default ForwardRef;